import tripEvents from './../../config/events.constant';

export default function TripDetailsSendController(
    $scope,
    tripId,
    l10nService,
    tripAPI,
    tripOptionsService,
    ktAlert,
    tripDetails
) {
    'ngInject';

            const quoteReviewDefault = {
                    TripId: tripDetails.Id,
                    ReviewerContactIds: [],
                    ReviewerEmailAddresses: [],
                    CoverNote: '',
                };
            const quoteDefault = {
                    coverNote: '',
                    reviewerData: {},
                    emailsList: [],
                };
            const reviewerError = {
                    isListEmpty: false,
                    emptyContact: false,
                    duplicate: false,
                };

            $scope.quote = angular.copy(quoteDefault);
            $scope.reviewerError = angular.copy(reviewerError);
            $scope.personsToReview = [];

            $scope.reviewData = {
                markAsCC: false,
            };

            $scope.onReviewerEmailSelect = function() {
                $scope.quoteReview.reviewerContacts.$setValidity('pattern', true);
            };

            $scope.addReviewer = function(contactData) {
                let personToSend = {};

                $scope.reviewerError = angular.copy(reviewerError);

                if (!contactData) {
                    $scope.reviewerError.emptyContact = true;
                    return false;
                }

                if (contactData.ContactId) {
                    personToSend = {
                        EmailAddress: contactData.EmailAddress,
                        ContactId: contactData.ContactId,
                    };
                } else {
                    personToSend = {
                        EmailAddress: contactData,
                    };
                }

                /**
                 * Skip if already present in list
                 */
                if (isPresentInMailsList($scope.quote, personToSend)) {
                    $scope.reviewerError.duplicate = true;
                    $scope.quote.reviewerData = {};

                    return false;
                }

                /**
                 * Clear Field with data
                 */
                $scope.reviewerError.duplicate = angular.copy(reviewerError.duplicate);
                $scope.quote.reviewerData = {};

                /**
                 * Add data to emails list
                 */
                $scope.quote.emailsList.push(personToSend);
            };

            $scope.sendQuote = function(form) {
                if (form.$invalid) {
                    return false;
                }

                if (!$scope.quote.emailsList.length) {
                    $scope.reviewerError.isListEmpty = true;
                    return false;
                }

                const quoteReview = makeRequestToReview($scope.quote);

                tripAPI.sendQuote(quoteReview)
                    .then(() => {
                        $scope.toggleSendBlock();
                        ktAlert.success(l10nService.localize('Trip shared'));
                        $scope.reviewerError = angular.copy(reviewerError);
                        $scope.$emit(tripEvents.TRIP_DETAILS_UPDATE);
                    })
                    .catch(({data}) => ktAlert.error(data.ErrorMessage));
            };

            $scope.cancelSendQuote = function() {
                $scope.toggleSendBlock();

                $scope.quoteReview.$setPristine();
                $scope.quoteReview.$setValidity();

                /**
                 * Reset default objects
                 */
                $scope.quote = angular.copy(quoteDefault);
                $scope.quoteReview.reviewerContacts.$setViewValue(undefined);
                $scope.quoteReview.reviewerContacts.$render();

                /**
                 * Clear forms
                 */
                $scope.reviewerError = angular.copy(reviewerError);
            };

            $scope.getPersons = function(data) {
                if (data && data.length < 3) {
                    return false;
                }

                return tripAPI.getPersonsToReview({searchString: data}).then(function(response) {
                    return _.map(response.data, function(item) {
                        item.title = item.Name + ' (' + item.EmailAddress + ')';
                        return item;
                    });
                });
            };

            $scope.removeReviewer = function($index) {
                const emailsList = $scope.quote.emailsList;

                emailsList[$index] = null;
                $scope.quote.emailsList = _.compact(emailsList);
            };

            $scope.isContactSelected = isContactSelected;
            $scope.removeReviewError = removeReviewError;

            function isPresentInMailsList(quote, personToSend) {
                let result = false;
                _.each(quote.emailsList, function(email) {
                    result = result || _.contains(email, personToSend.EmailAddress);
                });
                return result;
            }

            function makeRequestToReview(quote) {
                const quoteReview = angular.copy(quoteReviewDefault);

                _.each(quote.emailsList, function(quoteItem) {
                    if (quoteItem.ContactId) {
                        quoteReview.ReviewerContactIds.push(quoteItem.ContactId);
                    } else {
                        quoteReview.ReviewerEmailAddresses.push(quoteItem.EmailAddress);
                    }
                });
                quoteReview.CoverNote = quote.coverNote;

                return quoteReview;
            }

            function isContactSelected() {
                return angular.isObject($scope.quote.reviewerData.personTitle);
            }

            function removeReviewError() {
                $scope.reviewerError = angular.copy(reviewerError);
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/controllers/details/tripDetailsSendController.js